import type { StateAction } from "@entrilia/shared/types";
import type { ValidationResult } from "@entrilia/shared/utilities/validators";
import {
  combineValidators,
  requiredValidator,
  uniqueValidator,
  validResult,
} from "@entrilia/shared/utilities/validators";
import type { DataModelConfiguration } from "../../../../api/types/dataModelConfigurationTypes";

interface EditConfigurationState {
  name: string;
  validationResult: ValidationResult;
  editedConfiguration: DataModelConfiguration | undefined;
  otherNames: string[];
}

export const getInitialEditConfigurationState = (
  allConfigurations: DataModelConfiguration[],
  editedConfiguration?: DataModelConfiguration
): EditConfigurationState => ({
  name: editedConfiguration?.name ?? "",
  validationResult: validResult(),
  editedConfiguration,
  otherNames: allConfigurations.filter((c) => c.id !== editedConfiguration?.id).map((c) => c.name),
});

// Actions

const validate = (otherNames: string[]) =>
  combineValidators(requiredValidator, uniqueValidator("Configuration with this name already exists", otherNames));

export const updateNameAction =
  (value: string): StateAction<EditConfigurationState> =>
  (state) => ({
    ...state,
    name: value,
    validationResult: validate(state.otherNames)(value),
  });

// Selectors

export const isFormDirty = (state: EditConfigurationState) => {
  if (!state.editedConfiguration) {
    return state.name.trim() !== "";
  }

  return state.name.trim().toLowerCase() !== state.editedConfiguration.name.trim().toLowerCase();
};
